import { Coach } from "@/models";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  coach: new Coach(),
  coaches: [],
  coachLoading: false,
  coachesLoading: false,
  coachMail: "",
  coachMailLoading: false,
  meta: {},
  deleteImages: [],
  deleteImagesLoading: false,
  singleCoach: [],
  singleCoachLoading: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
